/* eslint-disable no-secrets/no-secrets */
import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { AdditionalInterestComponent } from "premier-capability-policyjob-react";
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices } from 'premier-capability-hooks';
import { useTranslator } from '@jutro/locale';
import styles from '../../components/Miscellaneous/Miscellanous.module.scss';
import presentationMetadata from './PropertyCoveragesPage.metadata.json5';
import messages from './PropertyCoveragesPage.messages';
import CoveragesPageComponent from "../Coverages/CoveragesPage";

function PropertyCoveragesPage(props) {
    const { authHeader } = useAuthentication();
    const {
        wizardData, updateWizardData, currentStep, callbackMap
    } = props;
    const { pageKey } = currentStep;
    // eslint-disable-next-line security/detect-object-injection
    const metadata = presentationMetadata[pageKey];
    const { initialValidation, onValidate } = useValidation('PropertyPage');
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const translator = useTranslator();

    const onNext = useCallback(
        async () => {

            const {productCode} = wizardData.value.baseData;
            // eslint-disable-next-line security/detect-object-injection
            const lobLineName = lineName[productCode];

            wizardData.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', wizardData);

            return wizardData;
        },
        [lineName, updateSubmission, wizardData]
    );
    
    const getAccordianTitle = useCallback((index) => (
        <div className={styles.accordianTitle}>
          <p>
            {_.get(
              wizardData,
              `lobData.proLine.coverables.locRisks.children[${index}].accountAddressOfLocRisk.displayName.value`
            )}
          </p>
          <p>
            {`${translator(messages.totalInsValue)}${_.get(
              wizardData.value,
              `lobData.proLine.lineCoverages.locRiskCoverages.coverages[${index}].tivCalculation`
            ) !== undefined ? _.get(
              wizardData.value,
              `lobData.proLine.lineCoverages.locRiskCoverages.coverages[${index}].tivCalculation`
            ): 0}`}
          </p>
        </div>
      ),[translator, wizardData]);

    const propertyCoveragesOverrides = useMemo(() => {
        const informationList = _.get(wizardData, 'lobData.proLine.coverables.locRisks', []);
        let overrides = [];

        if (!_.isEmpty(informationList)) {
            overrides = informationList?.children.map((information, index) => ({
                [`locRiskCoverageComponent${index}`]: {
                    wizardData,
                    updateWizardData,
                    clausesBasePath: `lobData.proLine.lineCoverages.locRiskCoverages.coverages.children[${index}].coverages`,
                    title: messages.cov,
                    clasueType: 'coverages',
                    pathToGet: `proLine.locRiskCoverages.coverages[${index}].coverages`
                },
                [`additionalInterest${index}`]:{
                    value: wizardData,
                    path: `lobData.proLine.coverables.locRisks.children[${index}].additionalInterests`,
                    type: 'additionalInterest',
                    onValueChange: updateWizardData,
                    authHeader
                },
                [`propertyCoveragesAccordionDetails${index}`]: {                     
                    title: getAccordianTitle(index),
                    className: styles.gwOuterLocationAccordion
                },
                [`propertyCoveragesAccordion${index}`]: {
                    className: styles.gwAccordionSet
                }
            }));
        }

        return Object.assign({}, ...overrides);
    }, [authHeader, getAccordianTitle, updateWizardData, wizardData]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        optionalCoverageComponent: {
            wizardData,
            updateWizardData,
            clausesBasePath: `lobData.proLine.lineCoverages.propertyCoverages`,
            title: messages.cov,
            clasueType: 'coverages',
            pathToGet: `proLine.propertyCoverages`,
            visible: !_.isUndefined(_.get(wizardData.value, 'lobData.proLine.coverables.isOptionalCovVisible')) && _.get(wizardData.value, 'lobData.proLine.coverables.isOptionalCovVisible')  
        },
        optionalCoveragesPageTitle: {
            visible: !_.isUndefined(_.get(wizardData.value, 'lobData.proLine.coverables.isOptionalCovVisible')) && _.get(wizardData.value, 'lobData.proLine.coverables.isOptionalCovVisible') 
        },
        ...propertyCoveragesOverrides,

    };

    const resolveCallbackMap = {
        ...callbackMap
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, wizardData, id, path, overrideProps),
        [metadata.content, wizardData, overrideProps]
    );

    const resolveComponentMap = {
        coveragespagecomponent: CoveragesPageComponent,
        additionalInterestComponent: AdditionalInterestComponent
    };

    const isDisableNext = () => {
        let result = false
        
        _.each(wizardData.value.lobData.proLine.lineCoverages.locRiskCoverages.coverages, (locRiskCov) => {
            if (!result && !_.isUndefined(_.find(locRiskCov.coverages, { isValid: false }))) {
                result = true
            }
        });

        return result
    };

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={isDisableNext() || _.find(wizardData.value.lobData.proLine.lineCoverages.propertyCoverages, { isValid: false })}
            disableSave={isDisableNext() || _.find(wizardData.value.lobData.proLine.lineCoverages.propertyCoverages, { isValid: false })}
            onNext={onNext}
            onSave={onNext}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={wizardData}
                onModelChange={updateWizardData}
                callbackMap={resolveCallbackMap}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                componentMap={resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

PropertyCoveragesPage.propTypes = wizardProps;
export default withViewModelService(PropertyCoveragesPage);
